/*************************************************/
/* INTERSECTION OBSERVATION                      */
/*************************************************/

export function intersectionObservation() {
    const activeClass = 'in-view',
        targetsClasses = [".video-item__player", ".statistic-item__counter-value", ".steps-component__content"],
        defaultOptions = {
            rootMargin: '-150px'
        }

    const isMobile = () => window.innerWidth < 992;

    const getStepOptions = () => isMobile()
        ? { rootMargin: '-40% 0px -60% 0px', threshold: 0 }
        : { rootMargin: '-400px', threshold: [0, 0.25, 0.5, 0.75, 1.0] };

    const init = function () {
        let targets = [];
        for (var i = 0; i < targetsClasses.length; i++) {
            var targetElements = document.querySelectorAll(targetsClasses[i]);
            if (targetElements != null) {
                targets.push(...targetElements);
            }
        }

        if ('IntersectionObserver' in window) {

            let currentActiveIndex = -1;
            const visibilityMap = new Map();
            let lastVisibleIndex = 0;

            function activateStep(index) {
                if (index === currentActiveIndex) return;
                currentActiveIndex = index;

                const allContent = document.querySelectorAll(".steps-component__content");

                if (!isMobile()) {
                    const allImages = document.querySelectorAll(".steps-image-wrapper img");
                    const allVideos = document.querySelectorAll(".steps-image-wrapper .steps-video-wrapper");

                    allImages.forEach((img) => img.classList.remove("itemActive"));
                    allVideos.forEach((vid) => {
                        vid.classList.remove("itemActive");
                        const v = vid.querySelector("video");
                        if (v) { v.pause(); v.currentTime = 0; }
                    });

                    const videoWrapper = document.querySelector(`.steps-image-wrapper .steps-video-wrapper[data-index="${index}"]`);
                    if (videoWrapper) {
                        videoWrapper.classList.add("itemActive");
                        videoWrapper.querySelector("video")?.play();
                    } else {
                        document.querySelector(`.steps-image-wrapper img[data-index="${index}"]`)?.classList.add("itemActive");
                    }
                }

                allContent.forEach((item) => item.classList.remove("itemActive"));
                allContent[index]?.classList.add("itemActive");
            }

            function handleIntersection(entries) {
                entries.forEach((entry) => {

                    if (entry.target.dataset.autoplay) {
                        if (entry.isIntersecting) {
                            entry.target.click();
                            entry.target.classList.add(entry.target.classList[0] + "--" + activeClass);
                            observer.unobserve(entry.target);
                        }

                    } else if (entry.target.classList.contains('steps-component__content')) {

                        const index = parseInt(entry.target.dataset.index);
                        
                        if (isMobile()) {
                            if (entry.isIntersecting) {
                                activateStep(index);
                            }
                        } else {
                            visibilityMap.set(index, entry.intersectionRatio);

                            const anyVisible = Array.from(visibilityMap.values()).some(r => r > 0);

                            if (!anyVisible){
                                activateStep(lastVisibleIndex);
                                return;
                            }

                            let maxRatio = -1;
                            let mostVisibleIndex = 0;
                            visibilityMap.forEach((ratio, i) => {
                                if (ratio > maxRatio) {
                                    maxRatio = ratio;
                                    mostVisibleIndex = i;
                                }
                            });

                            lastVisibleIndex = mostVisibleIndex;
                            activateStep(mostVisibleIndex);
                        }

                    } else {
                        if (entry.isIntersecting) {
                            entry.target.classList.add(entry.target.classList[0] + "--" + activeClass);
                            observer.unobserve(entry.target);
                        }
                    }
                });
            }

            const observer = new IntersectionObserver(handleIntersection, defaultOptions);
            const stepObserver = new IntersectionObserver(handleIntersection, getStepOptions());

            targets.forEach(target => {
                if (target.classList.contains('steps-component__content')) {
                    const index = parseInt(target.dataset.index);
                    visibilityMap.set(index, 0);
                    stepObserver.observe(target);
                } else {
                    observer.observe(target);
                }
            });

        } else {
            targets.forEach(target => {
                target.classList.add(target.classList[0] + "--" + activeClass);
            });
        }
    };

    init();
}